<template>
  <div class="decisionManagement-page">
    <div v-loading="isLoading_" :element-loading-text="'当前控制模式切换中，时间较长，请勿点击其它操作，耐心等待'" class="all-content-container">
      <div class="decision-template-container">
        <div style="height: 40px">
          <div class="content-title-top">
            <h3>决策模型</h3>
          </div>
          <el-button style="width: 120px; display: inherit; float: right; margin-top: -30px; margin-right: 10px" @click="handleAdd" size="small" type="primary">+添加决策模型</el-button>
          <el-button style="width: 120px; display: inherit; float: right; margin-top: -30px; margin-right: 10px" @click="handleToCrop" size="small" type="primary">+添加作物</el-button>
          <el-button style="width: 120px; display: inherit; float: right; margin-top: -30px; margin-right: 10px" @click="handleAI" size="small" type="primary">AI2.0调控室</el-button>
          <!-- <el-button style="
              width: 120px;
              display: inherit;
              float: right;
              margin-top: -30px;
              margin-right: 10px;
            " @click="gotoEcharts" size="small" type="primary">数据分析</el-button> -->
        </div>
      </div>
      <div class="growthModelCard" v-loading="isLoading" :element-loading-text="timeShow ? '' : '当前生长模型下发中，涉及的数据较多，时间较长，请勿点击其它操作，耐心等待'">
        <el-row :gutter="10">
          <el-col :span="12" class="content" v-for="(item, index) in tableData" :key="index">
            <div class="grid-content bg-purple">
              <div class="growth-titile-container">
                <div style="line-height: 3.5rem; color: black">
                  <span style="font-weight: bold; font-size: 17px; color: #333333; line-height: 20px; text-align: left; font-style: normal">
                    {{ item.cropName }}
                  </span>
                  <span style="font-weight: 500; font-size: 14px; color: #333333; line-height: 20px; text-align: left; font-style: normal">
                    {{ `(${item.groupName})` }}
                  </span>
                </div>
                <div class="a3336">
                  <!-- <el-select style="margin-left: 5rem;" @change="getNew" v-model="item.value" placeholder="请选择统计分析">
                    <el-option v-for="citem in item.path" :key="citem.value" :label="citem.label" :value="[item, citem.value]">
                    </el-option>

                  </el-select> -->
                  <div class="flex">
                    <span class="open_button_1" style="color: black">控制模式</span>
                    <div class="celect" style="width: 190px; margin-left: 1rem">
                      <el-select style="width:50%; !important" @change="handleStatus_($event, item.groupId)" size="mini" v-model="item.deviceStaus" placeholder="请选择">
                        <el-option label="远程控制模式" :value="0"> </el-option>
                        <el-option label="定时控制模式" :value="1"> </el-option>
                        <el-option label="AI自动模式" :value="2"> </el-option>
                      </el-select>
                    </div>
                    <span class="open_button_1" style="color: black">决策模型</span>
                    <div class="celect" style="width: 120px; margin-left: 1rem">
                      <el-select style="width:30%; !important" @change="handleStatus($event, item.id, item.deviceStaus)" size="mini" v-model="item.status" placeholder="请选择">
                        <el-option label="禁用" :value="0"> </el-option>
                        <el-option label="启用" :value="1"> </el-option>
                        <!-- <el-option label="暂停" :value="2"> </el-option> -->
                        <!-- <el-option label="控制柜任务下发" :value="3"> </el-option> -->
                      </el-select>
                    </div>
                    <div class="open_button_" @click="openTimeTask(item.id, item)">
                      <img style="margin-right: 5px" src="../../assets/images/xfjl.png" alt="" />
                      下发记录
                    </div>
                    <!-- <div class="open_button_" @click="openAddit(item.id)">
                      <img style="margin-right:5px" src="../../assets/images/dsrw.png" alt="">
                      定时任务
                    </div> -->
                  </div>
                  <!-- <button class="btnEditC" style="width: 100px" @click="handleData(item)">
                    历史参数比对
                  </button>
                  <button class="btnEditC" style="width: 80px" @click="handleGrowth(item)">
                    生长记录      
                  </button>
                  <button class="btnEditC" @click="handleWeather(item)">
                    天气
                  </button>
                  <button class="btnEditC" style="width: 80px" @click="handletimer(item)">
                    调控记录
                  </button>  -->
                </div>
              </div>
              <img class="h" src="../../assets/images/h.png" alt="" />
              <div class="growth-content-container">
                <div class="growth-content-left">
                  <img :src="item.recentGrowthPic ? item.recentGrowthPic : item.cropImage" alt onerror="this.onerror='';this.src='../../assets/images/default.png'" />
                </div>
                <div class="open_button_ a235" @click="handleEdit(item.id, item.status)">
                  <img style="margin-right: 5px" src="../../assets/images/bj.png" alt="" />
                  编辑
                </div>
                <div class="growth-content-right">
                  <div class="a697">
                    <div class="a13">
                      <div class="over_text flex_12">
                        <img class="trile" src="../../assets/img/zw.png" alt="" />
                        <span>作物名称：</span>{{ item.cropName }}
                      </div>
                      <div class="over_text flex_12">
                        <img class="trile" src="../../assets/img/jd.png" alt="" />
                        <span>当前生长阶段：</span>{{ item.sendDto.currentGrowthStageName }}
                      </div>
                      <!-- <div class="over_text flex">
                      <div class="trile"></div>
                      <span>当前处于该生长阶段第：</span>
                      <span v-if="item.status ==1 &&item.aTime<item.sendDto.currentGrowthStageCycle">
                        {{item.aTime}}天
                      </span>
                      <span v-if="item.status ==0">
                        生长模型已禁用
                      </span>
                      <span v-if="item.status ==2">
                        生长模型已暂停
                      </span>
                      <span v-if="item.aTime>item.sendDto.currentGrowthStageCycle">
                        生长模型已完成
                      </span>
                    </div> -->
                    </div>
                    <div class="a13">
                      <div class="over_text flex_12">
                        <img class="trile" src="../../assets/img/ai.png" alt="" />
                        <span>生长模型：</span>{{ item.sendDto.modelName }}
                      </div>
                      <div class="over_text flex_12">
                        <img class="trile" src="../../assets/img/zq.png" alt="" />
                        <span>当前生长周期：</span>{{ item.sendDto.currentGrowthStageCycle }}天
                      </div>
                      <!-- <div class="over_text flex">
                      <div class="trile"></div>
                      <span style="white-space: nowrap;">生长全阶段：</span>{{ item.sendDto.allGrowthStageName }}
                    </div>
                    <div class="over_text flex">
                      <div class="trile"></div>
                      <span>生长全周期：</span>{{ item.sendDto.allGrowthStageCycle }}天
                    </div>
                    <div class="over_text flex">
                      <div class="trile"></div>
                      <span>定植日期：</span>{{ item.startDate.slice(0,11) }}
                    </div> -->
                      <!-- <p class="over_text">
                    <span>定时排程：</span>{{ item.modelStageName }}
                  </p> -->
                      <!-- <div class="over_text flex">
                      <div class="trile"></div>
                      <span>维护人员：</span>{{ item.sendDto.maintenanceStaff }}
                    </div> -->
                    </div>
                  </div>
                  <div class="a6654">
                    <div class="over_text flex_12">
                      <img class="trile" src="../../assets/img/dq.png" alt="" />
                      <span>当前处于该生长阶段第：</span>
                      <span style="color: #333" v-if="item.status == 1 && item.aTime < item.sendDto.currentGrowthStageCycle"> {{ item.aTime }}天 </span>
                      <span style="color: #333" v-if="item.status == 0"> 生长模型已禁用 </span>
                      <span style="color: #333" v-if="item.status == 2"> 生长模型已暂停 </span>
                      <span style="color: #333" v-if="item.status == 3"> 生长模型已完成 </span>
                    </div>
                    <div class="over_text flex_12">
                      <img class="trile" src="../../assets/img/szq.png" alt="" />
                      <span style="white-space: nowrap">生长全阶段：</span>{{ item.sendDto.allGrowthStageName }}
                    </div>
                    <div class="over_text flex_12">
                      <img class="trile" src="../../assets/img/sz.png" alt="" />
                      <span>生长全周期：</span>{{ item.sendDto.allGrowthStageCycle }}天
                    </div>
                    <div class="over_text flex_12">
                      <img class="trile" src="../../assets/img/dz.png" alt="" />
                      <span>定植日期：</span>{{ item.sendDto.plantingDate }}
                    </div>

                    <div class="over_text flex_12">
                      <img class="trile" src="../../assets/img/wh.png" alt="" />
                      <span>维护人员：</span>{{ item.sendDto.maintenanceStaff }}
                    </div>
                  </div>

                  <!-- <p class="over_text" style="display: block">
                    <span>模型周期：</span>{{ item.modelTimeName }}
                    <span style="color: red" v-if="item.remainingDays != undefined && item.remainingDays > 0">
                      剩余{{ item.remainingDays }}天</span>
                    <button v-if="item.cycleStatus == 1" class="btnEditC" @click="handleConfirm(item)">
                      确认
                    </button>
                    <button v-if="item.cycleStatus == 1" class="btnEditC" @click="handleExtend(item)">
                      延长
                    </button>
                  </p> -->
                  <!-- <p class="over_text">
                    <span>当前最佳生长条件：</span>
                    {{ item.recentGrowthConditions }}
                  </p>
                  <p class="over_text">
                    <span>当前实际环境：</span>
                    {{ item.currentPhysicalEnvironment }}
                  </p>
                  <p class="over_text">
                    <span class>最近决策执行的动作：</span>
                    {{ item.recentExecutionActions }}
                  </p> -->
                </div>
              </div>
              <img class="h" src="../../assets/images/h.png" alt="" />
              <div class="growth-opt-container">
                <div style="display: flex; justify-content: space-between; width: 100%" class="growth-opt-div">
                  <div style="width: 50%"></div>
                  <div class="flex">
                    <div class="open_button_" @click="openCmdTaskList(item)">
                      <img style="margin-right: 5px" src="../../assets/images/xfjl.png" alt="" />
                      历史报文下发记录
                    </div>
                    <div class="open_button_" @click="openDevice(item)">
                      <img style="margin-right: 5px" src="../../assets/images/sbkz.png" alt="" />
                      设备调控组件
                    </div>
                    <div class="open_button_" @click="handletimer(item)">
                      <img style="margin-right: 5px" src="../../assets/images/tksj.png" alt="" />
                      调控时间轴
                    </div>
                    <div class="open_button_" @click="openTimeTask_(item.id, item)">
                      <img style="margin-right: 5px" src="../../assets/images/sbkz.png" alt="" />
                      设备控制记录
                    </div>
                    <div class="open_button_" @click="_openVideo(item.groupId, item)">
                      <img style="margin-right: 5px" src="../../assets/images/spjk.png" alt="" />
                      视频监控
                    </div>
                  </div>

                  <div>
                    <!-- <button @click="handleDel(item.id)">删除</button> -->
                  </div>

                  <!-- <button class="btnEditC" @click="handleStatus(item.id)" v-if="item.status == 0">
                    启用
                  </button>
                  <button class="btnEditC" @click="handleStatus(item.id)" v-if="item.status == 1">
                    禁用
                  </button> -->
                </div>
              </div>
            </div>
          </el-col>
          <div class="empty-box" v-if="tableData.length == 0">
            <img :src="empty_img" />
          </div>
        </el-row>
      </div>
      <div class="pagination-content-container" style="">
        <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" :total="total"></el-pagination>
      </div>
    </div>

    <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
      <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="大棚名称：" prop="groupIdArr">
              <el-cascader expand-trigger="hover" v-model="ruleForm.groupIdArr" :options="groupArray" :props="optionProps" @change="groupChange" placeholder="请选择大棚名称" collapse-tags clearable></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="农作物：" prop="cropId">
              <el-select v-model="ruleForm.cropId" placeholder="请选择农作物" clearable @change="cropChange">
                <el-option v-for="item in cropArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="环境模型：" prop="modelEvnId">
              <el-select v-model="ruleForm.modelEvnId" placeholder="请选择环境模型" clearable>
                <el-option v-for="item in modelEvnArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="生长模型：" prop="modelId">
              <el-select v-model="ruleForm.modelId" placeholder="请选择生长模型" clearable @change="modelChange">
                <el-option v-for="item in modelArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="生长阶段：" prop="modelStageId">
              <el-select v-model="ruleForm.modelStageId" placeholder="请选择生长阶段" clearable @change="modelStageChange">
                <el-option v-for="item in modelStageArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="生长周期：" prop="modelTimeId">
              <el-select v-model="ruleForm.modelTimeId" placeholder="请选择生长周期" clearable>
                <el-option v-for="item in modelTimeArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="延长周期天数" :visible.sync="extendIsDialog" :before-close="handleCancelExtend" width="600px" center style="z-index: 10000">
      <el-form ref="ruleFormExtend" :rules="rulesExtend" :model="ruleFormExtend" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="延长天数：" prop="num">
              <el-input-number v-model="ruleFormExtend.num" placeholder="请输入延长天数" size="small" :max="9999" :min="1" :step="1" :precision="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelExtend">取 消</el-button>
        <el-button type="primary" @click="handleSaveExtend">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="定时任务" :visible.sync="timedTaskDialog" width="900px" center style="z-index: 10000">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="灯光" name="0"> </el-tab-pane>
        <el-tab-pane label="滴灌" name="1"></el-tab-pane>
        <el-tab-pane label="外风机" name="2"></el-tab-pane>
        <el-tab-pane label="内风机" name="3"></el-tab-pane>
      </el-tabs>
      <div class="a23">
        <div>
          <el-button type="primary" size="small" @click="openAddit_">新增配置</el-button>
        </div>
        <div>
          <el-button type="primary" size="small" v-if="activeName == 0" @click="handleSaveExtend_A(activeName)">灯光定时任务下发</el-button>
          <el-button type="primary" size="small" v-if="activeName == 1" @click="handleSaveExtend_A(activeName)">滴灌定时任务下发</el-button>
          <el-button type="primary" size="small" v-if="activeName == 2" @click="handleSaveExtend_A(activeName)">外风机定时任务下发</el-button>
          <el-button type="primary" size="small" v-if="activeName == 3" @click="handleSaveExtend_A(activeName)">内风机定时任务下发</el-button>
          <el-button type="primary" size="small" @click="openTimeTask_1">下发记录查询</el-button>
        </div>
      </div>

      <div class="table_content1" style="margin-top: 10px">
        <el-table :data="tableData_" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
          <el-table-column prop="orderNum" align="center" label="定时分组" width></el-table-column>
          <el-table-column align="center" label="执行星期" width>
            <template slot-scope="scope">
              <span v-if="scope.row.weekTime == 1">星期一</span>
              <span v-if="scope.row.weekTime == 2">星期二</span>
              <span v-if="scope.row.weekTime == 3">星期三</span>
              <span v-if="scope.row.weekTime == 4">星期四</span>
              <span v-if="scope.row.weekTime == 5">星期五</span>
              <span v-if="scope.row.weekTime == 6">星期六</span>
              <span v-if="scope.row.weekTime == 7">星期七</span>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" align="center" label="开始时间" width></el-table-column>
          <el-table-column prop="endTime" align="center" label="结束时间" width></el-table-column>
          <el-table-column align="center" label="启用状态" width>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">已禁用</span>
              <span v-if="scope.row.status == 1">已启用</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作" width="260">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 0" @click="updateGrowthModelDecisionScheduleStatus(scope.row.id)" type="text" size="small">启用</el-button>
              <el-button style="color: red" v-if="scope.row.status == 1" @click="updateGrowthModelDecisionScheduleStatus(scope.row.id)" type="text" size="small">禁用</el-button>
              <el-button @click="updatabox(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button style="color: red" type="text" size="small" @click="delModelAlarmSettings(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleCancelExtend1">取 消</el-button> -->
      </div>
    </el-dialog>
    <el-dialog title="定时任务配置" :visible.sync="extendIsDialog_" width="600px" center style="z-index: 10000">
      <el-form ref="ruleFormExtend" :rules="rulesExtend" :model="ruleFormTime" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="定时分组：">
              <el-input-number size="small" v-model="ruleFormTime.orderNum" :min="1" :max="100" label="定时分组"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="定时范围：" prop="time">
              <el-time-picker is-range v-model="ruleFormTime.time" range-separator="至" start-placeholder="开启时间" value-format="HH:mm" format="HH:mm" end-placeholder="关闭时间" placeholder="选择时间范围"> </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="执行星期：" prop="weekTime">
              <el-select v-model="ruleFormTime.weekTime" clearable placeholder="请选择执行星期">
                <el-option label="星期一" value="1"></el-option>
                <el-option label="星期二" value="2"></el-option>
                <el-option label="星期三" value="3"></el-option>
                <el-option label="星期四" value="4"></el-option>
                <el-option label="星期五" value="5"></el-option>
                <el-option label="星期六" value="6"></el-option>
                <el-option label="星期七" value="7"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelExtend">取 消</el-button>
        <el-button type="primary" @click="handleSaveExtend_Time">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="ds_name" :visible.sync="timedTaskDialog_" :before-close="handleClose_1234" width="1000px" center style="z-index: 10000">
      <el-col :span="12">
        <div class="flex" style="margin: 10px">
          <div class="titii">操作时间：</div>
          <el-date-picker v-model="searchFormtimeTask.time" type="datetimerange" :picker-options="pickerOptions" @change="getTime_" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="flex" style="margin: 10px">
          <div class="titii">下发内容：</div>
          <el-input v-model="searchFormtimeTask.content" placeholder="请输入内容"></el-input>
        </div>
      </el-col>
      <el-col :span="4" style="margin: 7px">
        <el-button type="primary" class="status_open a33" @click="getGrowthModelDecisionHisDataSendList"> 查询 </el-button>
        <el-button type="primary" class="status_open a33" @click="reasta12"> 重置 </el-button>
      </el-col>
      <div class="table_content1" style="margin-top: 10px">
        <el-table :data="timeTsktableData" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
          <el-table-column prop="content" align="center" label="下发内容" width></el-table-column>
          <el-table-column align="center" label="下发类型" width>
            <template slot-scope="scope">
              <span v-if="scope.row.type == 0">手动</span>
              <span v-if="scope.row.type == 1">定时任务</span>
            </template>
          </el-table-column>
          <el-table-column prop="realName" align="center" label="下发人" width></el-table-column>

          <el-table-column prop="updateTime" align="center" label="创建修改时间" width></el-table-column>
          <el-table-column align="center" label="操作" width="260">
            <template slot-scope="scope">
              <el-button @click="open_vw(scope.row.cmds, 0)" type="text" size="small">报文下发记录</el-button>
              <el-button type="text" size="small" @click="open_vw(scope.row.detailContent, 1)">生长模型下发记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <div class="page"></div>
        <div class="pagination-content-container">
          <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange_" :current-page="searchFormtimeTask.pageNum" :page-size="searchFormtimeTask.pageSize" :total="searchFormtimeTask.total"></el-pagination>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose_1234">确 定</el-button>
      </div> -->
    </el-dialog>
    <el-dialog :title="conName" :visible.sync="controlRecordDialog" :before-close="handleClose_123" width="1000px" center style="z-index: 10000">
      <el-col :span="12">
        <div class="flex" style="margin: 10px">
          <div class="titii">操作时间：</div>
          <el-date-picker v-model="searchFormControlRecord.time" type="datetimerange" :picker-options="pickerOptions" @change="getTime" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="flex" style="margin: 10px">
          <div class="titii">操作内容：</div>
          <el-input v-model="searchFormControlRecord.content" placeholder="请输入内容"></el-input>
        </div>
      </el-col>
      <el-col :span="4" style="margin: 7px">
        <el-button type="primary" class="status_open a33" @click="getGrowthModelDecisonDataControlList"> 查询 </el-button>
        <el-button type="primary" class="status_open a33" @click="reasta1"> 重置 </el-button>
      </el-col>
      <div class="table_content1" style="margin-top: 10px">
        <el-table :data="ControlRecordtableData" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
          <el-table-column prop="controlContent" align="center" label="控制内容" width></el-table-column>
          <el-table-column prop="cotrolTime" align="center" label="控制时间" width></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <div class="page"></div>
        <div class="pagination-content-container">
          <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange_1" :current-page="searchFormControlRecord.pageNum" :page-size="searchFormControlRecord.pageSize" :total="searchFormControlRecord.total"></el-pagination>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose_123">确 定</el-button>
      </div> -->
    </el-dialog>
    <el-dialog :title="cs_name" :visible.sync="TimingTaskRecording" :before-close="handclose_99" width="1100px" center style="z-index: 10000">
      <el-col :span="12">
        <div class="flex" style="margin: 10px">
          <div class="titii">操作时间：</div>
          <el-date-picker v-model="searchFormTimingTaskRecording.time" type="datetimerange" :picker-options="pickerOptions" @change="getTime_1" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
        </div>
      </el-col>
      <el-col :span="4" style="margin: 7px">
        <el-button type="primary" class="status_open a33" @click="getGrowthModelDecisionScheduleHisDataSendList"> 查询 </el-button>
        <el-button type="primary" class="status_open a33" @click="reasta13"> 重置 </el-button>
      </el-col>
      <div class="table_content1" style="margin-top: 10px">
        <el-table :data="TimingTaskRecordingtableData" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
          <el-table-column prop="orderNum" align="center" label="定时分组" width="70px"></el-table-column>
          <el-table-column align="center" label="执行星期" width>
            <template slot-scope="scope">
              <span v-if="scope.row.weekTime == 1">星期一</span>
              <span v-if="scope.row.weekTime == 2">星期二</span>
              <span v-if="scope.row.weekTime == 3">星期三</span>
              <span v-if="scope.row.weekTime == 4">星期四</span>
              <span v-if="scope.row.weekTime == 5">星期五</span>
              <span v-if="scope.row.weekTime == 6">星期六</span>
              <span v-if="scope.row.weekTime == 7">星期七</span>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" align="center" label="开启时间" width></el-table-column>
          <el-table-column prop="endTime" align="center" label="关闭时间" width></el-table-column>
          <el-table-column align="center" label="状态" width>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">已禁用</span>
              <span v-if="scope.row.status == 1">已启用</span>
            </template>
          </el-table-column>
          <el-table-column prop="realName" align="center" label="下发人" width></el-table-column>
          <el-table-column prop="updateTime" align="center" label="下发时间" width="250"></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <div class="page"></div>
        <div class="pagination-content-container">
          <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange_2" :current-page="searchFormTimingTaskRecording.pageNum" :page-size="searchFormControlRecord.pageSize" :total="searchFormControlRecord.total"></el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handclose_99">确 定</el-button>
      </div>
    </el-dialog>
    <div v-drag class="draggable" v-if="isVideo" width="70%">
      <img v-if="isVideo_" @click="dbclose" class="img_del" src="@/assets/img/del.png" alt="" />
      <div class="box_">
        <div v-if="attachmentLink.length > 0" class="center">
          <video style="margin-bottom: 20px" id="videoPlayer" class="video-js vjs-default-skin" controls playsinline autoplay="autoplay" width="700px">
            <source :src="attachmentLink[0].playM3u8" type="application/x-mpegURL" />
          </video>
        </div>
        <div class="center" v-else>
          <img :src="empty_img" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer a12">
        <div></div>
        <div>
          <!-- <el-button style="margin:20px" @click="isVideo = false">确定</el-button> -->
        </div>
        <!-- <el-button type="primary" @click="isMore = false">确 定</el-button> -->
      </span>
    </div>
    <el-dialog :title="bw_name" :visible.sync="TimingTaskRecording_" :before-close="handclose_999" width="1100px" center style="z-index: 10000">
      <div class="table_content1" style="margin-top: 10px">
        <el-table v-if="Ttype == 0" :data="ListT" align="center" class="data-table" style="width: 100%" height="350" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
          <el-table-column prop="remark" align="center" label="内容"></el-table-column>
          <el-table-column prop="cmd" align="center" label="报文"></el-table-column>
          <el-table-column align="center" label="状态" width>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">下发中</span>
              <span v-if="scope.row.status == 1">下发成功</span>
              <span v-if="scope.row.status == 2">下发失败</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" align="center" label="下发时间"></el-table-column>
        </el-table>
        <el-table v-if="Ttype == 1" :data="ListT" align="center" class="data-table" style="width: 100%" height="350" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
          <el-table-column prop="name" align="center" label="属性名称"></el-table-column>
          <el-table-column prop="startTime" align="center" label="开始时间"></el-table-column>
          <el-table-column align="center" label="结束时间">
            <template slot-scope="scope">
              <span>{{ scope.row.endTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="minValue" align="center" label="最小值"></el-table-column>
          <el-table-column prop="maxValue" align="center" label="最大值"></el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handclose_999">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设备调控组件" :visible.sync="deviceDialog" width="1500px" center style="z-index: 10000">
      <div v-loading="isload" :element-loading-text="'当前命令下发中，时间较长，请勿点击其它操作，耐心等待'">
        <el-col :span="16">
          <div class="flex" style="margin: 10px">
            <el-tabs v-model="ruleFormTime_Device.attrType" @tab-click="getGrowthModelDecisionDeviceComponents">
              <el-tab-pane label="空气温度" name="4"></el-tab-pane>
              <el-tab-pane label="空气湿度" name="5"></el-tab-pane>
              <el-tab-pane label="CO2浓度" name="2"></el-tab-pane>
              <el-tab-pane label="土壤湿度" name="1"></el-tab-pane>
              <el-tab-pane label="光照强度" name="0"></el-tab-pane>
              <!-- <el-tab-pane label="内风机" name="3"></el-tab-pane> -->
            </el-tabs>
            <!-- <el-select @change="getGrowthModelDecisionDeviceComponents" v-model="ruleFormTime_Device.type" clearable placeholder="请选择设备类型">
              <el-option label="风机" value="0"></el-option>
              <el-option label="滴灌" value="1"></el-option>
              <el-option label="补光灯" value="2"></el-option>
              <el-option label="锅炉" value="3"></el-option>
              <el-option label="内保温" value="4"></el-option>
              <el-option label="侧保温" value="5"></el-option>
              <el-option label="外遮阳" value="6"></el-option>
              <el-option label="内遮阳" value="7"></el-option>
              <el-option label="湿帘" value="8"></el-option>
            </el-select> -->
          </div>
        </el-col>
        <el-col :span="7" style="margin: 7px">
          <el-button type="primary" class="status_open button_34" @click="sendGrowthModelDecisionDeviceComponents"> 组件命令下发 </el-button>
          <el-button type="primary" class="status_open button_34" @click="openDeviceList"> 下发记录 </el-button>
          <el-button type="primary" class="status_open button_35" @click="openCmdTaskList1"> 历史报文下发记录 </el-button>
        </el-col>
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="modelList" align="center" class="data-table" style="width: 100%" v-loading="isLoading" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column v-for="(item, index) in tableListy" :key="index" align="center" :label="item[index]" width>
              <template slot-scope="scope">
                <el-switch @change="getMore(item.id)" v-model="scope.row[index]" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"> </el-switch>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="状态" width>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="设备调控组件下发记录" :visible.sync="deviceRecording" :before-close="handclose_device" width="1200px" center style="z-index: 10000">
      <el-col :span="5">
        <div class="flex" style="margin: 10px">
          <div class="titii">调控类型：</div>
          <el-select @change="searchList" v-model="searchFormdeviceRecording.attrType" clearable placeholder="请选择设备类型">
            <el-option label="补光灯" value="0"></el-option>
            <el-option label="滴灌" value="1"></el-option>
            <el-option label="外风机" value="2"></el-option>
            <el-option label="内风机" value="3"></el-option>
            <el-option label="空气温度" value="4"></el-option>
            <el-option label="空气湿度" value="5"></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="flex" style="margin: 10px">
          <div class="titii">设备类型：</div>
          <el-select @change="searchList" v-model="searchFormdeviceRecording.type" clearable placeholder="请选择设备类型">
            <el-option label="风机" value="0"></el-option>
            <el-option label="滴灌" value="1"></el-option>
            <el-option label="补光灯" value="2"></el-option>
            <el-option label="锅炉" value="3"></el-option>
            <el-option label="内保温" value="4"></el-option>
            <el-option label="侧保温" value="5"></el-option>
            <el-option label="外遮阳" value="6"></el-option>
            <el-option label="内遮阳" value="7"></el-option>
            <el-option label="湿帘" value="8"></el-option>
          </el-select>
        </div>
      </el-col>

      <el-col :span="8">
        <div class="flex" style="margin: 10px">
          <div class="titii">操作时间：</div>
          <el-date-picker v-model="searchFormdeviceRecording.time" type="datetimerange" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
        </div>
      </el-col>
      <el-col :span="4" style="margin: 7px">
        <el-button type="primary" class="status_open a33" @click="searchList"> 查询 </el-button>
        <el-button type="primary" class="status_open a33" @click="reastadevice"> 重置 </el-button>
      </el-col>
      <div class="table_content1" style="margin-top: 10px">
        <el-table :data="decisionDeviceComponentsData" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
          <el-table-column prop="name" align="center" label="名称" width></el-table-column>
          <el-table-column align="center" label="状态" width>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">已禁用</span>
              <span v-if="scope.row.status == 1">已启用</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" align="center" label="时间" width></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <div class="page"></div>
        <div class="pagination-content-container">
          <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange_3" :current-page="searchFormdeviceRecording.pageNum" :page-size="searchFormdeviceRecording.pageSize" :total="searchFormdeviceRecording.total"></el-pagination>
        </div>
      </div>
    </el-dialog>
    <Info ref="info"></Info>
  </div>
</template>
<script>
import Info from '../timedTask/components/info.vue'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import moment from 'moment'
export default {
  components: {
    Info
  },
  data() {
    return {
      ruleFormTime_Device: {
        attrType: '4',
        id: ''
      },
      deviceRecording: false,
      deviceDialog: false,
      activeName: 0,
      value: '',
      isLoading: true,
      isLoading_: false,
      empty_img: require('../../assets/img/timg.jpg'),
      currentPage: 1, //第几页，默认1
      pageSize: 6, //默认展示多少条，默认10``
      total: 0,
      tableData: [],
      tableData_: [],
      ruleForm: {
        // 添加编辑弹窗表单字段
        id: '',
        groupIdArr: [],
        groupId: '',
        cropId: '',
        modelEvnId: '',
        modelId: '',
        modelStageId: '',
        modelTimeId: ''
      },
      devicId_: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近五天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 5)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      rules: {
        // 添加编辑弹窗表单规则
        groupIdArr: [
          {
            required: true,
            message: '请选择大棚名称',
            trigger: 'change'
          }
        ],
        cropId: [
          {
            required: true,
            message: '请选择农作物',
            trigger: 'change'
          }
        ],
        modelEvnId: [
          {
            required: true,
            message: '请选择环境模型',
            trigger: 'change'
          }
        ],
        modelId: [
          {
            required: true,
            message: '请选择生长模型',
            trigger: 'change'
          }
        ],
        modelStageId: [
          {
            required: true,
            message: '请选择生长阶段',
            trigger: 'change'
          }
        ],
        modelTimeId: [
          {
            required: true,
            message: '请选择生长周期',
            trigger: 'change'
          }
        ],
        time: [
          {
            required: true,
            message: '请输入时间范围',
            trigger: 'change'
          }
        ]
      },
      ruleFormTime: {
        decisionId: '',
        endTime: '',
        orderNum: '',
        startTime: '',
        type: '',
        weekTime: '',
        id: '',
        time: ''
      },
      addEditTitle: '添加决策模型', // 添加编辑弹窗标题
      addEditId: '', // 添加编辑ID
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      },
      groupArray: [], // 大棚名称数组
      cropArray: [], // 农作物数组
      modelEvnArray: [], // 环境模型数组
      modelArray: [], // 生长模型数组
      modelStageArray: [], // 生长阶段数组
      modelTimeArray: [], // 生长周期数组
      timer: '',
      ruleFormExtend: {
        // 延长周期弹窗表单字段
        decisionId: '',
        num: ''
      },
      rulesExtend: {
        // 延长周期弹窗表单规则
        num: [
          {
            required: true,
            message: '请输入延长天数',
            trigger: 'blur'
          }
        ]
      },
      extendIsDialog: false, // 延长周期弹窗是否显示
      timedTaskDialog: false,
      extendIsDialog_: false,
      timeShow: true,
      timedTaskDialog_: false,
      controlRecordDialog: false,
      TimingTaskRecording: false,
      timeNow: 60,
      timeId: '',
      timeTsktableData: [],
      searchFormtimeTask: {
        id: '',
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        content: ''
      },
      ControlRecordtableData: [],
      searchFormControlRecord: {
        id: '',
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        content: ''
      },
      TimingTaskRecordingtableData: [],
      searchFormTimingTaskRecording: {
        id: '',
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        content: ''
      },
      searchFormdeviceRecording: {
        decisionId: '',
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        type: '',
        attrType: ''
      },
      conName: '',
      ds_name: '',
      cs_name: '',
      isVideo: false,
      attachmentLink: [],
      isVideo_: false,
      ListT: [],
      TimingTaskRecording_: false,
      bw_name: '',
      Ttype: '',
      modelList: [],
      isload: false,
      decisionDeviceComponentsData: [],
      tableListy: []
    }
  },
  created() {
    // 查询
    this.handleSearch()
    // 获取分组列表
    this.getGroupList()
  },
  mounted() {
    this.timer = setInterval(() => {
      this.getGrowthModelDecisionList()
    }, 10000)
  },
  // 销毁
  beforeDestroy() {
    if (this.dp) {
      this.dp.dispose() // dispose()会直接删除Dom元素
    }
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  directives: {
    drag: {
      // 指令的定义
      bind: function (el) {
        console.log(el)
        let oDiv = el // 获取当前元素
        oDiv.onmousedown = e => {
          // 算出鼠标相对元素的位置
          let disX = e.clientX - oDiv.offsetLeft
          let disY = e.clientY - oDiv.offsetTop
          document.onmousemove = e => {
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置·
            let left = e.clientX - disX
            let top = e.clientY - disY
            oDiv.style.left = left + 'px'
            oDiv.style.top = top + 'px'
          }
          document.onmouseup = e => {
            document.onmousemove = null
            document.onmouseup = null
          }
        }
      }
    }
  },
  methods: {
    gotoEcharts() {
      this.$router.push({
        path: '/growthModelHisParamControlChart_1'
      })
    },
    sendGrowthModelDecisionDeviceComponents() {
      this.isload = true
      this.$api.growthModel.sendGrowthModelDecisionDeviceComponents({ id: this.ruleFormTime_Device.id }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.isload = false
        }
      })
    },
    getMore(id) {
      this.$api.growthModel.saveGrowthModelDecisionDeviceComponents({ id: id }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getGrowthModelDecisionDeviceComponents()
        }
      })
    },
    openDevice(row) {
      this.deviceDialog = true

      this.ruleFormTime_Device.id = row.id
      this.ruleFormTime_Device.attrType = '4'
      this.getGrowthModelDecisionDeviceComponents()
    },
    getGrowthModelDecisionDeviceComponents() {
      this.$api.growthModel.getGrowthModelDecisionDeviceComponents({ decisionId: this.ruleFormTime_Device.id, attrType: this.ruleFormTime_Device.attrType }).then(res => {
        if (res.code == 200) {
          this.modelList = []
          let arr = []
          let obj = {}
          res.data.map((item, index) => {
            let c = {}
            c[index] = item.name
            c.id = item.id
            obj[index] = item.status
            arr.push(c)
          })
          this.tableListy = arr
          this.modelList.push(obj)
        }
      })
    },
    handleSaveExtend_Device() {
      this.$api.growthModel.sendGrowthModelDecisionScheduleCmd(this.ruleFormTime_Device).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.deviceDialog = false
        }
      })
    },
    open_vw(val, type) {
      this.ListT = []
      this.Ttype = type
      if (type == 0) {
        this.ListT = val
        this.bw_name = '报文下发记录'
      } else {
        console.log(JSON.parse(val), 69)
        this.ListT = JSON.parse(val)
        this.bw_name = '生长模型下发记录'
      }
      this.TimingTaskRecording_ = true
    },
    _openVideo(id) {
      this.getVideosByGroupId(id)
      setTimeout(() => {
        this.isVideo_ = true
      }, 1800)
    },
    getVideosByGroupId(id) {
      this.$api.device.getVideosByGroupId({ id: id }).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.attachmentLink = res.data

            this.isVideo = true
          } else {
            this.$message({
              type: 'warning',
              message: '该决策模型暂无绑定监控设备'
            })
            this.isVideo = false
          }
          setTimeout(() => {
            this.loadVideo()
          }, 1000)
        }
      })
    },
    dbclose() {
      if (this.isVideo == true) {
        var video = videojs('videoPlayer')
        video.dispose()
      }
      this.isVideo_ = false
      this.isVideo = false
    },
    loadVideo() {
      this.db = videojs(`videoPlayer`, this.options_)
      // this.attachmentLink.map((item, index) => {
      //   this.db = videojs(`videoPlayer${index}`, this.options_)
      // })
    },
    // 跳转农作物界面
    handleToCrop() {
      this.$router.push({
        name: 'cropsManagement'
      })
    },
    handleClose_123() {
      this.controlRecordDialog = false
      this.searchFormControlRecord = {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        content: ''
      }
    },
    reasta1() {
      this.searchFormControlRecord.startTime = ''
      this.searchFormControlRecord.endTime = ''
      this.searchFormControlRecord.time = ''
      this.searchFormControlRecord.pageNum = 1
      this.searchFormControlRecord.content = ''
      this.getGrowthModelDecisonDataControlList()
    },
    reasta12() {
      this.searchFormtimeTask.startTime = ''
      this.searchFormtimeTask.endTime = ''
      this.searchFormtimeTask.time = ''
      this.searchFormtimeTask.content = ''
      this.searchFormtimeTask.pageNum = 1
      this.getGrowthModelDecisionHisDataSendList()
    },
    reasta13() {
      this.searchFormTimingTaskRecording.startTime = ''
      this.searchFormTimingTaskRecording.endTime = ''
      this.searchFormTimingTaskRecording.time = ''
      this.searchFormTimingTaskRecording.content = ''
      this.getGrowthModelDecisionScheduleHisDataSendList()
    },
    reastadevice() {
      this.searchFormdeviceRecording.startTime = ''
      this.searchFormdeviceRecording.endTime = ''
      this.searchFormdeviceRecording.time = ''
      this.searchFormdeviceRecording.type = ''
      this.searchFormdeviceRecording.attrType = ''
      this.getGrowthModelDecisionDeviceComponentsDataHisList()
    },
    searchList() {
      this.searchFormdeviceRecording.pageNum = 1

      this.getGrowthModelDecisionDeviceComponentsDataHisList()
    },
    openDeviceList() {
      this.deviceRecording = true
      this.searchFormdeviceRecording.type = ''
      this.searchFormdeviceRecording.attrType = '0'
      this.getGrowthModelDecisionDeviceComponentsDataHisList()
    },

    handclose_99() {
      this.TimingTaskRecording = false
      this.searchFormTimingTaskRecording = {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        content: ''
      }
    },
    handclose_999() {
      this.TimingTaskRecording_ = false
    },
    handclose_device() {
      this.deviceRecording = false
    },
    handleClose_1234() {
      this.timedTaskDialog_ = false
      this.searchFormtimeTask = {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        content: ''
      }
    },
    openTimeTask(val, item) {
      this.$prompt('请输入密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password'
      })
        .then(({ value }) => {
          this.$api.growthModel.verifyPasswd({ str: value }).then(res => {
            if (res.code == 200) {
              this.timedTaskDialog_ = true
              this.searchFormtimeTask.id = val
              this.ds_name = `${item.groupName}_${item.cropName}_决策模型调控记录`
              this.getGrowthModelDecisionHisDataSendList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    openTimeTask_(val, item) {
      this.controlRecordDialog = true
      console.log(item)
      this.conName = `${item.groupName}_${item.cropName}_设备控制记录`
      this.searchFormControlRecord.id = val
      this.getGrowthModelDecisonDataControlList()
    },
    openTimeTask_1(val) {
      if (this.activeName == 0) {
        this.cs_name = '灯光定时下发任务'
      } else if (this.activeName == 1) {
        this.cs_name = '滴灌定时下发任务'
      } else if (this.activeName == 2) {
        this.cs_name = '外风机定时下发任务'
      } else if (this.activeName == 3) {
        this.cs_name = '内风机定时下发任务'
      }
      this.TimingTaskRecording = true
      this.searchFormTimingTaskRecording.id = this.timeId
      this.getGrowthModelDecisionScheduleHisDataSendList()
    },

    handleClick(tab, event) {
      console.log(tab, event)
      this.getGrowthModelDecisionSchedules()
    },
    openAddit(val) {
      this.timeId = val
      this.timedTaskDialog = true
      this.getGrowthModelDecisionSchedules()
    },
    handleCurrentChange_(currentPage) {
      this.searchFormtimeTask.pageNum = currentPage
      this.getGrowthModelDecisionHisDataSendList()
    },
    handleCurrentChange_1(currentPage) {
      this.searchFormControlRecord.pageNum = currentPage
      this.getGrowthModelDecisonDataControlList()
    },
    handleCurrentChange_2(currentPage) {
      this.searchFormTimingTaskRecording.pageNum = currentPage
      this.getGrowthModelDecisionScheduleHisDataSendList()
    },
    handleCurrentChange_3(currentPage) {
      this.searchFormdeviceRecording.pageNum = currentPage
      this.getGrowthModelDecisionDeviceComponentsDataHisList()
    },
    getGrowthModelDecisionScheduleHisDataSendList() {
      this.searchFormTimingTaskRecording.type = this.activeName
      this.$api.growthModel.getGrowthModelDecisionScheduleHisDataSendList(this.searchFormTimingTaskRecording).then(res => {
        if (res.code == 200) {
          res.data.map(item => {
            item.updateTime = moment(item.updateTime).format('YYYY-MM-DD HH:mm:ss')
          })
          this.TimingTaskRecordingtableData = res.data
          this.searchFormTimingTaskRecording.total = res.count
        }
      })
    },
    getGrowthModelDecisionDeviceComponentsDataHisList() {
      this.searchFormdeviceRecording.startTime = this.searchFormdeviceRecording.time[0]
      this.searchFormdeviceRecording.endTime = this.searchFormdeviceRecording.time[1]
      this.searchFormdeviceRecording.decisionId = this.ruleFormTime_Device.id
      this.$api.growthModel.getGrowthModelDecisionDeviceComponentsDataHisList(this.searchFormdeviceRecording).then(res => {
        if (res.code == 200) {
          this.decisionDeviceComponentsData = res.data
          this.searchFormdeviceRecording.total = res.count
        }
      })
    },
    getGrowthModelDecisonDataControlList() {
      console.log(this.searchFormControlRecord)
      this.$api.growthModel.getGrowthModelDecisonDataControlList(this.searchFormControlRecord).then(res => {
        if (res.code == 200) {
          res.data.map(item => {
            item.updateTime = moment(item.updateTime).format('YYYY-MM-DD HH:mm:ss')
          })
          this.ControlRecordtableData = res.data
          this.searchFormControlRecord.total = res.count
        }
      })
    },
    getTime(val) {
      this.searchFormControlRecord.startTime = val[0]
      this.searchFormControlRecord.endTime = val[1]
      this.getGrowthModelDecisonDataControlList()
      console.log(223)
    },

    getGrowthModelDecisionHisDataSendList() {
      this.$api.growthModel.getGrowthModelDecisionHisDataSendList(this.searchFormtimeTask).then(res => {
        if (res.code == 200) {
          res.data.map(item => {
            item.updateTime = moment(item.updateTime).format('YYYY-MM-DD HH:mm:ss')
          })
          this.timeTsktableData = res.data
          this.searchFormtimeTask.total = res.count
        }
      })
    },
    getTime_(val) {
      this.searchFormtimeTask.startTime = val[0]
      this.searchFormtimeTask.endTime = val[1]
      this.getGrowthModelDecisionHisDataSendList()
    },
    getTime_1(val) {
      this.searchFormTimingTaskRecording.startTime = val[0]
      this.searchFormTimingTaskRecording.endTime = val[1]
      this.getGrowthModelDecisionScheduleHisDataSendList()
    },

    getGrowthModelDecisionSchedules() {
      this.$api.growthModel.getGrowthModelDecisionSchedules({ decisionId: this.timeId, type: this.activeName }).then(res => {
        if (res.code == 200) {
          this.tableData_ = res.data
        }
      })
    },
    getNew(val) {
      console.log(val)
      if (val[1] == 0) {
        this.handlePlan(val[0])
      } else if (val[1] == 1) {
        this.handleData(val[0])
      } else if (val[1] == 2) {
        this.handleGrowth(val[0])
      } else if (val[1] == 3) {
        this.handleWeather(val[0])
      } else if (val[1] == 4) {
        this.$router.push({
          name: `growthModelTimer`,
          query: {
            decisionId: val[0].groupId,
            cropName: val[0].cropName,
            groupName: val[0].groupName
          }
        })
      }
    },
    // 分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getGrowthModelDecisionList()
    },

    // 查询
    handleSearch() {
      this.currentPage = 1
      this.getGrowthModelDecisionList()
    },
    // 查询全部决策模型列表
    getGrowthModelDecisionList() {
      this.$api.growthModel
        .getGrowthModelDecisionList({
          pageNum: this.currentPage,
          pageSize: this.pageSize
        })
        .then(res => {
          this.isLoading = false
          if (res.code == 200) {
            console.log(res.data, 669)
            res.data.map(item => {
              var date1 = new Date(item.currentModelStartDate) // 第一个日期
              var date2 = new Date() // 当前日期（默认为系统当前日期）
              // 获取两个日期之间的毫秒数差值
              var timeDiff = Math.abs(date2 - date1)
              var diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))
              item.aTime = diffDays
              console.log(diffDays, 996)
            })
            this.tableData = res.data
            this.tableData.map(item => {
              item.path = [
                { value: 0, label: '补光记录' },
                { value: 1, label: '调控结果偏差核对' },
                { value: 2, label: '生长记录' },
                { value: 3, label: '天气' },
                { value: 4, label: '调控记录' }
              ]
              this.$api.growthModel.getBoxStatus({ id: item.groupId }).then(res => {
                if (res.code == 200) {
                  if (res.data) {
                    item.deviceStaus = Math.round(res.data.value)
                    console.log(item, 698)
                    this.$forceUpdate()
                  }
                }
              })
              item.timeNow = 60
              item.timeShow = true
            })
            console.log(this.tableData)
            this.total = res.count
          }
        })
    },
    getBoxStatus(id) {},
    // 删除
    handleDel(id) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.growthModel.delGrowthModelDecision(id).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleSearch()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    handleStatus_(val, id) {
      if (val != 2) {
        this.$api.growthModel.openOrCloseGrowthModelDecision({ groupId: id, status: 0, day: 0 })
      }
      let data = {
        groupId: id,
        status: val
      }
      this.$api.growthModel.changeBox(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.isLoading_ = true
          setTimeout(() => {
            this.isLoading_ = false
            this.$forceUpdate()
            // this.handleSearch()
            this.getGrowthModelDecisionList()
          }, 30000)
        }
      })
    },
    // 启用禁用
    handleStatus(id, index, i) {
      console.log(id, index, i, 898)
      clearInterval(this.timer)
      if (i != 2) {
        const h = this.$createElement
        this.$msgbox({
          title: '注意:',
          message: h('p', null, [h('i', { style: 'color: teal' }, '当前运行模式非AI自动模式，请切换模式后再进行操作。')]),
          confirmButtonText: '确定',
          beforeClose: (action, instance, done) => {
            this.getGrowthModelDecisionList()
            done()
          }
        }).then(action => {})
      } else {
        if (id == 1) {
          this.$prompt('请输入开始天数', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[1-9]\d*$/,
            inputErrorMessage: '天数格式不正确'
          })
            .then(({ value }) => {
              if (id == 3) {
                if (this.tableData[i].timeShow) {
                  this.isLoading = true
                  this.timeShow = false
                  console.log(this.timeShow)
                  this.tableData[i].timeShow = false
                  this.tableData[i].timeNow = 60
                  this.$forceUpdate()

                  let data = new FormData()
                  data.append('id', index)
                  this.$api.growthModel.sendCmdToBox(data).then(res => {
                    if (res.code == 200) {
                      this.$message({
                        type: 'success',
                        message: res.msg
                      })
                      this.timer = setInterval(() => {
                        this.getGrowthModelDecisionList()
                      }, 10000)
                      this.tableData[i].timeShow = true
                      this.timeShow = true
                      this.isLoading = false
                      this.$forceUpdate()
                      this.handleSearch()
                    }
                  })
                  console.log(i)
                } else {
                  this.$message({
                    type: 'warning',
                    message: '请稍后再点击'
                  })
                }
              } else {
                let status = ''
                if (id == 0) {
                  status = 0
                }
                if (id == 1) {
                  status = 1
                  this.isLoading = true
                  this.timeShow = false
                } else if (id == 2) {
                  status = 2
                }
                this.$api.growthModel.openOrCloseGrowthModelDecision({ id: index, status, day: value }).then(res => {
                  if (res.code == 200) {
                    this.$message({
                      type: 'success',
                      message: res.msg
                    })
                    this.timer = setInterval(() => {
                      this.getGrowthModelDecisionList()
                    }, 10000)
                    this.isLoading = false
                    this.timeShow = true
                    this.handleSearch()
                  } else {
                    this.isLoading = false
                    this.timeShow = true
                    this.handleSearch()
                  }
                })
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              })
              this.handleSearch()
            })
        } else {
          this.$confirm('请确认是否继续进行此操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              if (id == 3) {
                if (this.tableData[i].timeShow) {
                  this.isLoading = true
                  this.timeShow = false
                  console.log(this.timeShow)
                  this.tableData[i].timeShow = false
                  this.tableData[i].timeNow = 60
                  this.$forceUpdate()

                  let data = new FormData()
                  data.append('id', index)
                  this.$api.growthModel.sendCmdToBox(data).then(res => {
                    if (res.code == 200) {
                      this.$message({
                        type: 'success',
                        message: res.msg
                      })
                      this.tableData[i].timeShow = true
                      this.timeShow = true
                      this.isLoading = false
                      this.$forceUpdate()
                      this.handleSearch()
                    }
                  })
                  console.log(i)
                  // let timeNull = setInterval(() => {
                  //   if (this.tableData[i].timeNow > 1) {
                  //     this.tableData[i].timeNow--
                  //     this.$forceUpdate()
                  //   } else {
                  //     clearInterval(timeNull) // 当倒计时结束后清除定时器
                  //   }
                  // }, 1000)
                } else {
                  this.$message({
                    type: 'warning',
                    message: '请稍后再点击'
                  })
                }
              } else {
                let status = ''
                if (id == 0) {
                  status = 0
                }
                if (id == 1) {
                  status = 1
                  this.isLoading = true
                  this.timeShow = false
                } else if (id == 2) {
                  status = 2
                }
                this.$api.growthModel.openOrCloseGrowthModelDecision({ id: index, status }).then(res => {
                  if (res.code == 200) {
                    this.$message({
                      type: 'success',
                      message: res.msg
                    })
                    this.isLoading = false
                    this.timeShow = true
                    this.handleSearch()
                  }
                })
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              })
              this.handleSearch()
            })
        }
      }
    },
    openCmdTaskList(val) {
      this.$refs.info.searchFormTimingTaskRecording.decisionId = val.id
      this.$refs.info.searchFormTimingTaskRecording.taskType = 0
      this.$refs.info.openTimeTask_1()
    },
    openCmdTaskList1(val) {
      this.$refs.info.searchFormTimingTaskRecording.decisionId = this.ruleFormTime_Device.id
      this.$refs.info.searchFormTimingTaskRecording.taskType = 1
      // this.$refs.info.searchFormTimingTaskRecording.type = this.ruleFormTime_Device.attrType + ''
      this.$refs.info.openTimeTask_1()
    },
    // 编辑
    handleEdit(id, status) {
      if (status == 1) {
        const h = this.$createElement
        this.$msgbox({
          title: '注意:',
          message: h('p', null, [h('i', { style: 'color: teal' }, '当前生长模型启动中，请暂停或者禁用生长模型再操作')]),
          confirmButtonText: '确定',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {})
      } else {
        this.$router.push({
          name: `addDecisionModel`,
          query: {
            decisionId: id
          }
        })
      }
      // this.addEditIsDialog = true;
      // this.addEditTitle = "编辑决策模型";
      // this.addEditId = id;

      // // 获取详情
      // this.$api.growthModel.getGrowthModelDecision({ id: id }).then((res) => {
      //   if (res.code == 200) {
      //     this.ruleForm = res.data;
      //     this.ruleForm.groupIdArr = [
      //       this.getParentGroupId(res.data.groupId),
      //       res.data.groupId,
      //     ];

      //     this.getGrowthCropAll();
      //     this.getGrowthModelEvnAll();
      //     this.getGrowthModelAll();
      //     this.getGrowthModelStageAll();
      //     this.getGrowthModelTimeAll();
      //   }
      // });
    },
    handleAI() {
      // this.addEditIsDialog = true;
      // this.addEditTitle = "添加决策模型";
      // this.addEditId = "";
      this.$router.push({
        name: `aiModal`,
      })
    },
    // 添加
    handleAdd() {
      // this.addEditIsDialog = true;
      // this.addEditTitle = "添加决策模型";
      // this.addEditId = "";
      this.$router.push({
        name: `addDecisionModel`,
        query: {
          decisionId: ''
        }
      })
    },
    // 取消
    handleCancel() {
      this.$refs['ruleForm'].resetFields()
      this.ruleForm = {
        id: '',
        groupIdArr: [],
        groupId: '',
        cropId: '',
        modelEvnId: '',
        modelId: '',
        modelStageId: '',
        modelTimeId: ''
      }
      this.addEditIsDialog = false
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '生长模型切换中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          this.ruleForm.id = this.addEditId
          this.$api.growthModel.saveGrowthModelDecision(this.ruleForm).then(res => {
            loading.close()
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancel()
              this.handleSearch()
            }
          })
        }
      })
    },
    // 大棚下拉切换
    groupChange() {
      // 不是三级分类
      if (this.ruleForm.groupIdArr.length !== 2) {
        this.ruleForm.groupIdArr = []
        return
      }
      this.ruleForm.groupId = this.ruleForm.groupIdArr[1]

      // 清空
      this.ruleForm.cropId = ''
      this.cropArray = []

      this.ruleForm.modelEvnId = ''
      this.modelEvnArray = []

      this.ruleForm.modelId = ''
      this.modelArray = []

      this.ruleForm.modelStageId = ''
      this.modelStageArray = []

      this.ruleForm.modelTimeId = ''
      this.modelTimeArray = []

      // 获取农作物列表
      this.getGrowthCropAll()

      // 获取环境模型列表
      this.getGrowthModelEvnAll()
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then(res => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      this.groupArray.every(function (val) {
        if (val.children) {
          let isEnd = false
          val.children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }

            return val2.id != groupId
          })

          return !isEnd
        }
      })

      return parentGroupId
    },
    // 获取农作物列表
    getGrowthCropAll() {
      this.$api.growthModel.getGrowthCropAll({ id: this.ruleForm.groupId }).then(res => {
        if (res.code == 200) {
          this.cropArray = res.data
        }
      })
    },
    // 农作物下拉切换
    cropChange() {
      // 清空
      this.ruleForm.modelId = ''
      this.modelArray = []

      this.ruleForm.modelStageId = ''
      this.modelStageArray = []

      this.ruleForm.modelTimeId = ''
      this.modelTimeArray = []

      // 获取生长模型列表
      this.getGrowthModelAll()
    },
    // 获取环境模型列表
    getGrowthModelEvnAll() {
      this.$api.growthModel.getGrowthModelEvnAll({ groupId: this.ruleForm.groupId }).then(res => {
        if (res.code == 200) {
          this.modelEvnArray = res.data
        }
      })
    },
    // 获取生长模型列表
    getGrowthModelAll() {
      this.$api.growthModel.getGrowthModelAll({ id: this.ruleForm.cropId }).then(res => {
        if (res.code == 200) {
          this.modelArray = res.data
        }
      })
    },
    // 生长模型下拉切换
    modelChange() {
      // 清空
      this.ruleForm.modelStageId = ''
      this.modelStageArray = []

      this.ruleForm.modelTimeId = ''
      this.modelTimeArray = []

      // 获取生长阶段列表
      this.getGrowthModelStageAll()
    },
    // 获取生长阶段列表
    getGrowthModelStageAll() {
      this.$api.growthModel.getGrowthModelStageAll({ modelId: this.ruleForm.modelId }).then(res => {
        if (res.code == 200) {
          this.modelStageArray = res.data
        }
      })
    },
    // 生长阶段下拉切换
    modelStageChange() {
      // 清空
      this.ruleForm.modelTimeId = ''
      this.modelTimeArray = []

      // 获取生长周期列表
      this.getGrowthModelTimeAll()
    },
    // 获取生长周期列表
    getGrowthModelTimeAll() {
      this.$api.growthModel.getGrowthModelTimeAll({ modelStageId: this.ruleForm.modelStageId }).then(res => {
        if (res.code == 200) {
          this.modelTimeArray = res.data
        }
      })
    },
    // 配置方案
    handlePlan(row) {
      this.$router.push({
        name: `groupPlan`,
        query: {
          decisionId: row.id
        }
      })
    },
    // 历史参数控制
    handleData(row) {
      this.$router.push({
        name: `growthModelHisParamControlChart`,
        query: {
          decisionId: row.id
        }
      })
    },
    // 生长记录
    handleGrowth(row) {
      this.$router.push({
        name: `growthDataHisCrop`,
        query: {
          decisionId: row.id
        }
      })
    },
    // 调控记录
    handletimer(row) {
      this.$router.push({
        name: `growthModelTimer`,
        query: {
          decisionId: row.id,
          groupId: row.groupId,
          cropName: row.cropName
        }
      })
    },
    // 天气
    handleWeather(row) {
      this.$router.push({
        name: `growthModelWeather`,
        query: {
          decisionId: row.id
        }
      })
    },
    // 确认
    handleConfirm(row) {
      this.$confirm('确认后不能修改，是否确认该周期？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.growthModel.updateCycleStatus({ id: row.id }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleSearch()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消确认')
        })
    },
    // 延长
    handleExtend(row) {
      this.addEditId = row.id
      this.ruleFormExtend.decisionId = row.id
      this.extendIsDialog = true
    },
    openAddit_() {
      this.addEditId = ''

      this.ruleFormTime = {
        decisionId: this.timeId,
        endTime: '',
        orderNum: '',
        startTime: '',
        type: this.activeName,
        weekTime: '',
        id: '',
        time: ''
      }
      this.extendIsDialog_ = true
    },
    updatabox(row) {
      this.addEditId = row
      this.ruleFormTime.id = row
      this.extendIsDialog_ = true
      this.getGrowthModelDecisionSchedule()
    },
    getGrowthModelDecisionSchedule() {
      this.$api.growthModel.getGrowthModelDecisionSchedule({ id: this.addEditId }).then(res => {
        if (res.code == 200) {
          res.data.time = [res.data.startTime, res.data.endTime]
          this.ruleFormTime = res.data
          console.log(this.ruleFormTime)
        }
      })
    },
    // 取消
    handleCancelExtend() {
      this.$refs['ruleFormExtend'].resetFields()
      this.ruleFormExtend = {
        decisionId: this.addEditId,
        num: ''
      }
      this.ruleFormTime = {
        decisionId: '',
        endTime: '',
        orderNum: '',
        startTime: '',
        type: '',
        weekTime: '',
        time: '',
        id: ''
      }
      this.extendIsDialog = false
      this.extendIsDialog_ = false
    },
    handleCancelExtend1() {
      this.timedTaskDialog = false
    },
    // 保存延长周期
    handleSaveExtend() {
      this.$refs['ruleFormExtend'].validate(valid => {
        if (valid) {
          this.$api.growthModel.plusCycleTime(this.ruleFormExtend).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancelExtend()
              this.handleSearch()
            }
          })
        }
      })
    },
    updateGrowthModelDecisionScheduleStatus(row) {
      this.$api.growthModel.updateGrowthModelDecisionScheduleStatus({ id: row }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getGrowthModelDecisionSchedules()
        }
      })
    },
    handleSaveExtend_A(type) {
      this.$alert('请确认是否继续此操作', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            this.$api.growthModel.sendGrowthModelDecisionScheduleCmd({ id: this.timeId, type }).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                // this.handleCancelExtend1()
                this.handleSearch()
              }
            })
          }
        }
      })
    },
    delModelAlarmSettings(row) {
      this.$api.growthModel.delGrowthModelDecisionSchedule(row).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getGrowthModelDecisionSchedules()
        }
      })
    },
    handleSaveExtend_Time() {
      this.$refs['ruleFormExtend'].validate(valid => {
        if (valid) {
          this.ruleFormTime.startTime = this.ruleFormTime.time[0]
          this.ruleFormTime.endTime = this.ruleFormTime.time[1]
          this.$api.growthModel.saveGrowthModelDecisionSchedule(this.ruleFormTime).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancelExtend()
              this.getGrowthModelDecisionSchedules()
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 1600px) {
  .el-col-lg-8 {
    width: 33.33333% !important;
  }
}

@import '@/style/decisionManagement.scss';

li {
  padding-left: 10px;
}

// ::deep .el-input__inner {
//   width: 90px !important;
// }

.content {
  min-height: 22.8rem !important;
}

.growth-titile-container {
  height: 3.5rem;
  line-height: 3.5rem;
  // min-width: 40rem;
  display: flex;
  justify-content: space-between;
}
.decisionManagement-page {
  padding-bottom: 0px;
}
.pageTap {
  padding-bottom: 15px;
}
.growth-opt-container {
  margin-top: 20px;
}
.status_open {
  color: black;
  font-size: 14px;
  // font-weight: bold;
  margin-top: 2px;
  // border: 1px solid black;
  // padding: 2px;
  // button {
  width: 126px !important;
  border-radius: 5px !important;
  height: 32px !important;
  color: #fff !important;
  // }
}
.status_open_ {
  background-color: #909399 !important;
}
.a33 {
  width: 60px !important;
}
.button_34 {
  width: 150px;
}
.button_35 {
  width: 150px !important;
}
.a2 {
  width: 110px !important;
  text-align: center !important;
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  margin-right: 20px !important;
}
.a23 {
  display: flex;
  justify-content: space-between;
}
.btnEditC_ {
  background-color: #256bff !important;
  color: #fff !important;
}
.flex {
  display: flex;

  align-items: center;
}
.titii {
  white-space: nowrap;
  margin-top: 5px;
}

::deep .el-date-editor {
  .el-range-separator {
    width: 12% !important;
  }
}
.a13 {
  height: 80px;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
}
.a3336 {
  display: flex;
  justify-content: space-around;
}
.draggable {
  position: absolute;
  width: 690px;
  min-height: 50%;
  background-color: transparent;
  top: 10%;
  left: 35%;
  cursor: move;
}
.box_ {
  width: 700px;
  height: 450px;
  overflow-y: auto;
}
.img_del {
  position: relative;
  float: right;
  // right: 3rem;
  top: 40px;
  z-index: 9999999999999 !important;
  cursor: pointer;
}
.trile {
  width: 16px;
  height: 16px;
  margin-right: 2px;
  // margin-top: 3px;
  // border-radius: 10px;
  // background: linear-gradient(270deg, rgba(255, 255, 255, 0.14) 0%, #9bccff 100%);
  // margin-top: 3px;
}
.open_button_ {
  margin-right: 15px;
  display: flex;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #256bff;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
  white-space: nowrap;
}
.open_button_1 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  font-style: normal;
}
.h {
  width: 100%;
}
.a235 {
  position: absolute;
  top: -10px;
  right: 0px;
}
.a697 {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-size: 16px;
}
.a6654 {
  font-size: 16px;
  line-height: 35px;
}
.flex_12 {
  display: flex;
  align-items: center;
}
.pagination-container {
  padding-bottom: 40px;
}
</style>
